
<div class="relative">
  <div class="ui vertical loader" :class="{'active': loadForm.waiting}"></div>
  <table class="chatListTable">
    <thead class="chatListTable__header">
      <tr>
        <th class="chatListTable__headerTitleChat">チャット</th>
        <th class="chatListTable__headerTitleUpdate">お問い合わせ日時</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="marunage in marunages" :key="marunage.id" class="chatListTable__row">
        <td class="chatListTable__column">
          <a :href="marunage.chat_url">お問合せ番号：{{ marunage.code }}</a>
          <span class="chatListTable__unread" v-if="unreadTotalCount(marunage) > 0">{{ unreadTotalCount(marunage) }}</span>
          <div class="chatListTable__roomMemberContainer">
            <span class="chatListTable__roomMember" title="コンシェルジュ"
                  :style="backgroundImage(imageUrl('/marunagekun.png'))"></span>
            <span v-for="each in marunage.marunage_shops" :key="each.id" v-if="each.chat_url" :title="each.shop.name" class="chatListTable__roomMember"
                  :style="backgroundImage(each.shop.main_image.urls.small_square)"></span>
          </div>
        </td>
        <td class="chatListTable__column">{{ marunage.created_at | formatDatetime }}</td>
      </tr>
    </tbody>
  </table>
</div>
